/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getAuthToken } from 'services/apiUtils';
import { UsuarioDTO } from 'utils/models/types';
import { setRedirectPath } from 'utils/redux/features/authSlice';

interface ProtegidoProps {
  roles: string[];
}

const Protegido = ({ roles }: ProtegidoProps) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const token = getAuthToken();
  const usuarioJSON = localStorage.getItem('usuario');
  let usuario: UsuarioDTO | null = null;
  try {
    usuario = usuarioJSON ? JSON.parse(usuarioJSON) : null;
  } catch {
    localStorage.removeItem('usuario');
  }
  const forbidden = usuario?.Rol && !roles.includes(usuario?.Rol);

  useEffect(() => {
    if (!token) {
      dispatch(setRedirectPath(location.pathname));
      navigate('/');
    }
  }, [location.pathname, dispatch, token]);

  if (forbidden) {
    return <Navigate to="/unauthorized" />;
  }

  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default Protegido;
